import React from "react";
import Button from "@mui/material/Button";
import { useTheme, lighten } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";

const OutlinedButton = React.forwardRef(function OutlinedButton(
  { to, state, text, color = "success", size = "large", sx = {}, ...props },
  ref,
) {
  const theme = useTheme();
  const mainColor = theme.palette[color]?.main || theme.palette.primary.main;

  return (
    <Button
      ref={ref}
      component={to ? RouterLink : undefined}
      to={to}
      state={state}
      variant="outlined"
      color={color}
      size={size}
      sx={{
        color: mainColor,
        borderColor: mainColor,
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: lighten(mainColor, 0.9),
          borderColor: mainColor,
        },
        ...sx,
      }}
      {...props}
    >
      {text}
    </Button>
  );
});

export default OutlinedButton;
